import { Grid } from "@material-ui/core";
import { useEffect, useReducer } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next"
import CustomAlert from "../../componentes/alerts/CustomAlert";
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import { DefaultDatagrid } from "../../componentes/datagrid/DefaultDatagrid";
import InputField from "../../componentes/form-fields/InputField/InputField";
import GridInputRow from "../../componentes/form-grids/GridInputRow";
import GridItemContainer from "../../componentes/form-grids/GridItemContainer";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import ControlService from "./ConsultControlService";
import CustomDatePicker from "../../componentes/form-fields/DatePicker/CustomDatePicker";
import DefaultChip from "../../componentes/chip/DefaultChip";
import { Typography } from "@mui/material";

const columns = (t) => [
    {
        field: "id",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} name="id" />;
        },
    },
    {
        field: "numberDocument",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="numberDocument" />;
        },
        template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="grey"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.numberDocument}
                        </Typography>}
                    />
                </>
            )
        }
    },
    {
        field: "dtDocument",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="dtDocument" />;
        },
    },
    {fiels:"cdStatus", visible: false},
    {
        field: "cdStatusDesc",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="status" />;
        },
        template: (props) => {
            let chipStyle;

            switch (props.cdStatus) {
                case 1:
                    chipStyle = "progress";
                    break;
                case 2:
                    chipStyle = "finished";
                    break;
                case 3:
                    chipStyle = "canceled";
                    break;
                default:
                    chipStyle = "grey";
                    break;
            }

            return (
                <>
                
                    <DefaultChip
                        style={chipStyle}
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.cdStatusDesc}
                        </Typography>}
                    />
                </>
            )
        }

    },
];

const columnsProduct = (t) => [
    {
        field: "idProduct",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} name="idProduct" />;
        },
    },
    {
        field: "productCode",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="productCode" />;
        },
         template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="grey"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.productCode}
                        </Typography>}
                    />
                </>
            )
        }
    },
    {
        field: "productName",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="productName" />;
        },
    },
    {
        field: "batch",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="batch" />;
        },
    },
    {
        field: "quantityBoxReceived",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="quantityBoxReceived" />;
        },
         template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="standard"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.quantityBoxReceived}
                        </Typography>}
                    />
                </>
            )
        }
    },
    {
        field: "quantityBoxRead",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="quantityBoxRead" />;
        },
         template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="standard"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.quantityBoxRead}
                        </Typography>}
                    />
                </>
            )
        }
    },
];

export const ConsultInput = () => {
    const { t } = useTranslation();
    const { control } = useForm();
    const userId = sessionStorage.getItem("userId");

    const initialState = {
        id: "",
        numberDocument: "",
        dtDocument: null,
        rows: [],
        rowsProduct: [],
        userId: userId,
        cdStatus: 1,
        success: false,
        error: false,
    };

    const reducer = (state, action) => {
        switch (action.type) {
            case 'update':
                return { ...state, ...action.data }
            case "clear":
                return initialState
            case 'success':
                return { ...state, success: true, error: false }
            case 'error':
                return { ...state, success: false, error: true }
            case 'close_alert':
                return { ...state, success: false, error: false }
            default:
                return new Error();
        }
    }

    const [state, dispatch] = useReducer(reducer, initialState);

    const { id, numberDocument, dtDocument, dtDocumentOriginal, cdStatus, receiptProduct } = state
    const { success, error, rows, rowsProduct, ...data } = state

    const handleChange = ({ target: { name, value } }) => {
        dispatch({ type: 'update', data: { [name]: value } }) 
    }

    const handleCancel = () => {
        ControlService
            .cancelReceipt(data)
            .then((response) => {
                if (response.status === 200) {
                    dispatch({ type: 'success' })
                    dispatch({ type: 'clear' })
                }
            })
            .catch((e) => dispatch({ type: 'error' }));
    }

    const handleSearch = () => {

        let request = { ...state };

        if (request.id) {
            request.id = parseInt(request.id, 10);
        } else {
            request.id = 0; // ou delete request.id;
        }

        if (request.dtDocument instanceof Date) {
            const d = request.dtDocument;
            request.dtDocument = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}T00:00:00`;
        } else {
            delete request.dtDocument;
        }

        ControlService
            .filterReceipt(request)
            .then((response) => {
                if (response.status === 200) {

                    const data = response.data.map(item => ({
                        ...item,
                        dtDocumentOriginal: item.dtDocument ? new Date(item.dtDocument) : null, // para picker
                        dtDocument: item.dtDocument 
                            ? new Date(item.dtDocument).toLocaleDateString('pt-BR') // para grid
                            : ''
                    }));

                    dispatch({ type: 'update', data: { rows: data } });
                }
            })
            .catch((e) => dispatch({ type: 'update', data: { rows: [] } }));
    }

    const handleCellClick = (rowData) => {
        
        dispatch({
            type: 'update', data: {
                id: rowData.id,
                numberDocument: rowData.numberDocument,
                dtDocument: rowData.dtDocumentOriginal,
                cdStatus: rowData.cdStatus // <-- guardando no state
            }
        })

        const request = { receiptProduct: rowData.id };

        ControlService
            .getById(request)
            .then((response) => {
                if (response.status === 200) {
                    dispatch({ type: 'update', data: { rowsProduct: response.data } });
                }
            })
            .catch((e) => dispatch({ type: 'update', data: { rowsProduct: [] } }));

    }

    const handleExport = () => {
        
        var dados = '';
        dados += "\n"
        dados += "PackingList\n"
        dados += `Número do Documento: ${state.numberDocument}\n`;

        let dtDoc = ""
        const dateDoc = new Date(state.dtDocument);
        const diaDoc = String(dateDoc.getDate()).padStart(2, '0');
        const mesDoc = String(dateDoc.getMonth() + 1).padStart(2, '0');
        const anoDoc = dateDoc.getFullYear();
        dtDoc = `${diaDoc}/${mesDoc}/${anoDoc}`;

        dados += `Data do Documento: ${dtDoc}\n\n`;
        dados += "Código Produto; Descrição Produto; Lote; Qtde. Caixas Recebidas; Qtde. Caixas Lidas;\n"
        
        rowsProduct.map((item) => {

            let dt = "";
            if (item.batch) 
            {
                const date = new Date(item.batch);
                const dia = String(date.getDate()).padStart(2, '0');
                const mes = String(date.getMonth() + 1).padStart(2, '0');
                const ano = date.getFullYear();
                dt = `${dia}/${mes}/${ano}`;
            }

            dados += `${item.productCode};${item.productName};${dt};${item.quantityBoxReceived};${item.quantityBoxRead}; \n`;
            
        })

        const blob = new Blob([dados], { type: "text/plain" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");

        link.download = `Exportação_PackingList.csv`;

        link.href = url;
        link.click();
    };

    return (
        <DefaultScreenAccordion
            isTab
            fields={
                <GridItemContainer>
                    <CustomAlert
                        success={success}
                        error={error}
                        handleCloseAlert={() => dispatch({ type: 'close_alert' })}
                    />
                    <GridInputRow>
                        <Grid item xs={12} sm={6} md={3}>
                            <InputField
                                name="id"
                                control={control}
                                defaultValue=""
                                onChange={handleChange}
                                value={id}
                                labelName={"idDocument"}
                                inputProps={{ maxLength: 20 }}
                                error={error && id === ""}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <InputField
                                iconLabelSwitch={
                                    <IconLabelSwitch name="description" labelName="numberDocument" />
                                }
                                name="numberDocument"
                                control={control}
                                defaultValue=""
                                onChange={handleChange}
                                value={numberDocument}
                                inputProps={{ maxLength: 20 }}
                                error={error && numberDocument === ""}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <CustomDatePicker
                                id="dtDocument"
                                name="dtDocument"
                                selectedDate={dtDocument}
                                handleChange={handleChange}
                                error={error && dtDocument === ""}
                            />
                        </Grid>
                        
                    </GridInputRow>
                    <SearchClearSaveRow
                        {...(rowsProduct.length > 0 && cdStatus === 1 && {
                            onDefaultClick: handleCancel, labelName:t("cancelRecepeit")
                        })}
                        {...(rowsProduct.length <= 0 && {
                            onClickSearch: handleSearch
                        })}
                        onClickClear={() => dispatch({ type: 'clear' })}
                        {...(rowsProduct.length > 0 && {
                            onClickExport: handleExport
                        })}
                    />
                    {(rows.length > 0 && rowsProduct.length === 0) ? (
                        <GridInputRow>
                            <Grid item xs={12}>
                                <DefaultDatagrid
                                    columns={columns(t)}
                                    dataSource={rows}
                                    allowPaging={true}
                                    cellSelected={(args, grid) =>
                                        handleCellClick(args.data)
                                    } />
                                    
                            </Grid>
                        </GridInputRow>
                    ) : null}
                    {(rowsProduct.length > 0) ? (
                        <GridInputRow>
                            <Grid item xs={12}>
                                <DefaultDatagrid
                                    columns={columnsProduct(t)}
                                    dataSource={rowsProduct}
                                    allowPaging={true}
                                />
                            </Grid>
                        </GridInputRow>
                    ) : null}
                </GridItemContainer>
            } />
    );
}